var _circle, _circle2, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhyRes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 131,
    viewBox: "0 0 130 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65.9404,
    r: 60,
    fill: "#E59311"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65.9404,
    r: 62.5,
    stroke: "#E59311",
    strokeOpacity: 0.3,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 125.94C98.1371 125.94 125 99.0775 125 65.9404C125 55.6136 122.391 45.8961 117.796 37.4111C107.247 28.1923 93.442 22.6069 78.332 22.6069C45.1949 22.6069 18.332 49.4698 18.332 82.6069C18.332 92.9338 20.9409 102.651 25.5356 111.136C36.0845 120.355 49.89 125.94 65 125.94Z",
    fill: "#F9A623"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14765_51117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 31,
    width: 70,
    height: 70
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31H30V101H100V31Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14765_51117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7343 35C46.1235 35 44.796 36.3125 45.026 37.9069C45.9921 44.6052 50.2549 50.4718 56.4845 53.4333V93.3335C56.4845 94.9439 57.79 96.2499 59.4009 96.2499C61.0118 96.2499 62.3177 94.9439 62.3177 93.3335V75.8335H68.1509V93.3335C68.1509 94.9439 69.4568 96.2499 71.0677 96.2499C72.6786 96.2499 73.9841 94.9439 73.9841 93.3335V53.4041C80.2137 50.4682 84.4767 44.6047 85.4427 37.9069C85.6728 36.3125 84.345 35 82.7341 35C81.1237 35 79.847 36.3186 79.5268 37.8973C78.9615 40.6856 77.5878 43.2703 75.5464 45.312C74.1919 46.6662 72.5845 47.7403 70.8153 48.4732C69.0456 49.2061 67.1495 49.5833 65.2341 49.5833C61.3666 49.5833 57.657 48.0469 54.9222 45.312C52.8807 43.2703 51.5069 40.6856 50.9416 37.8973M65.2341 35C61.997 35 59.4009 37.5958 59.4009 40.8333C59.4009 44.0708 61.997 46.6666 65.2341 46.6666C68.4716 46.6666 71.0677 44.0708 71.0677 40.8333C71.0677 37.5958 68.4716 35 65.2341 35Z",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2657 35C83.8765 35 85.204 36.3125 84.974 37.9069C84.0079 44.6052 79.7451 50.4718 73.5155 53.4333V93.3335C73.5155 94.9439 72.21 96.2499 70.5991 96.2499C68.9882 96.2499 67.6823 94.9439 67.6823 93.3335V75.8335H61.8491V93.3335C61.8491 94.9439 60.5432 96.2499 58.9323 96.2499C57.3214 96.2499 56.0159 94.9439 56.0159 93.3335V53.4041C49.7863 50.4682 45.5233 44.6047 44.5573 37.9069C44.3272 36.3125 45.655 35 47.2659 35C48.8763 35 50.153 36.3186 50.4732 37.8973C51.0385 40.6856 52.4122 43.2703 54.4536 45.312C55.8081 46.6662 57.4155 47.7403 59.1847 48.4732C60.9544 49.2061 62.8505 49.5833 64.7659 49.5833C68.6334 49.5833 72.343 48.0469 75.0778 45.312C77.1193 43.2703 78.4931 40.6856 79.0584 37.8973M64.7659 35C68.003 35 70.5991 37.5958 70.5991 40.8333C70.5991 44.0708 68.003 46.6666 64.7659 46.6666C61.5284 46.6666 58.9323 44.0708 58.9323 40.8333C58.9323 37.5958 61.5284 35 64.7659 35Z",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhyRes);
export default __webpack_public_path__ + "static/media/phyRes.8fc6bddc32b39712b0e997d06eb3b99b.svg";
export { ForwardRef as ReactComponent };